import React, { useEffect, useState } from "react";
import {
  Button,
  Row,
  Layout,
  Input,
  Form,
  Upload,
  message,
  Typography,
  Alert,
  Popconfirm,
  Card,
  Checkbox,
  Col,
  Breadcrumb,
} from "antd";
import { DeleteOutlined, InboxOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../../utils/Auth/AuthWrapper";
import {
  aboutus_create,
  aboutus_get,
  contactus_create,
  contactus_get,
} from "../../services/aboutus";
import { upload_file } from "../../services/uploads";
import MenuBar from "../createNews/components/MenuBar";
import EditorContentPage from "../../components/Editor";
import { useTranslation } from "react-i18next";
import "../createAboutus/styles/index.less";

const { Content } = Layout;
const { Dragger } = Upload;
const { Title } = Typography;

const CreateAboutus: React.FC = () => {
  const navigate = useNavigate();
  const params = useParams();
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [imageUrl, setImageUrl] = useState<string | null>(null);
  const auth = useAuth();
  const [editorContentAbout, setEditorContentAbout] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [imageUrluse, setImageUrluse] = useState<File | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  // view image
  const getBase64 = (file: File, callback: (imageUrl: string) => void) => {
    const reader = new FileReader();
    reader.onload = () => callback(reader.result as string);
    reader.readAsDataURL(file);
  };

  // create about
  const handleCreateAbout = async (value: any) => {
    setSubmitting(true);
    try {
      let uploadedImgUrl = imageUrl;

      if (imageUrluse) {
        try {
          const uploadResponse = await upload_file({
            task_id: "about_image",
            type: "img_about",
            name: imageUrluse.name,
            file: imageUrluse,
          });

          if (uploadResponse.status === "success") {
            uploadedImgUrl = uploadResponse.link;
          } else {
            throw new Error("Failed to upload image.");
          }
        } catch (uploadError) {
          console.error("Error uploading image:", uploadError);
          message.error("Failed to upload image.");
          return;
        }
      }

      // เก็บข้อมูลในรูปแบบที่ต้องการ
      const res = await aboutus_create({
        data: {
          text: editorContentAbout || form.getFieldValue("details"),
          uploadedImgUrl: uploadedImgUrl || null,
          last_updated: form.getFieldValue("date"),
        },
      });

      const rescontact = await contactus_create({
        data: {
          facebook: form.getFieldValue("facebook"),
          facebook_show: form.getFieldValue("facebook_show"),
          Line: form.getFieldValue("Line"),
          Line_show: form.getFieldValue("Line_show"),
          Email: form.getFieldValue("Email"),
          Email_show: form.getFieldValue("Email_show"),
          Tiktok: form.getFieldValue("Tiktok"),
          Tiktok_show: form.getFieldValue("Tiktok_show"),
          Phonenumber: form.getFieldValue("Phonenumber"),
          Phonenumber_show: form.getFieldValue("Phonenumber_show"),
          location: form.getFieldValue("location"),
          location_show: form.getFieldValue("location_show"),
          address: form.getFieldValue("address"),
          address_show: form.getFieldValue("address_show"),
        },
      });

      if (res.status && rescontact.status === "success") {
        message.success("Submit Success!");
      }
    } catch (e) {
      console.error(e);
    }
    setSubmitting(false);
  };

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      await getAboutDetail();
      await getContactDetail();
      setIsLoading(false);
    };
    fetchData();
  }, []);

  // get about data
  const getAboutDetail = async () => {
    try {
      const res = await aboutus_get();
      if (res.data) {
        let rawDetails = JSON.parse(res.data[0].detail);
        // console.log("test about" , rawDetails);
        let extractedHtml = "";
        let uploadedImgUrl = "";
        if (Array.isArray(rawDetails)) {
          extractedHtml = rawDetails.map((item) => item.text).join("");
          uploadedImgUrl = rawDetails[0]?.uploadedImgUrl || "";
        } else if (rawDetails && rawDetails.text) {
          extractedHtml = rawDetails.text;
          uploadedImgUrl = rawDetails.uploadedImgUrl || "";
        }

        form.setFieldsValue({
          detail: extractedHtml,
          img: uploadedImgUrl,
        });

        setEditorContentAbout(extractedHtml || "");

        if (uploadedImgUrl) {
          const isExternalLink = /^(https:\/\/|http:\/\/|www\.)/i.test(
            uploadedImgUrl
          );
          const fullImagePath = isExternalLink
            ? uploadedImgUrl
            : `${process.env.REACT_APP_API}${uploadedImgUrl}`;

          setImageUrl(fullImagePath);
        } else {
          setImageUrl(null);
        }
      } else {
        console.error("No details found in the response");
      }
    } catch (error) {
      console.error("Failed to fetch news details", error);
    }
  };

  // get contact data
  const getContactDetail = async () => {
    try {
      const res = await contactus_get();
      if (res.data) {
        let rawDetails = JSON.parse(res.data[0].detail);
        form.setFieldsValue({
          facebook: rawDetails.facebook,
          facebook_show: rawDetails.facebook_show,
          Line: rawDetails.Line,
          Line_show: rawDetails.Line_show,
          Email: rawDetails.Email,
          Email_show: rawDetails.Email_show,
          Tiktok: rawDetails.Tiktok,
          Tiktok_show: rawDetails.Tiktok_show,
          Phonenumber: rawDetails.Phonenumber,
          Phonenumber_show: rawDetails.Phonenumber_show,
          address: rawDetails.address,
          address_show: rawDetails.address_show,
        });
      }
    } catch (error) {
      console.error("Failed to fetch news details", error);
    }
  };

  return (
    <div>
      <Content className="create-about-layout">
        <div>
          <Row justify="space-between" align="middle">
            <Breadcrumb
              separator=">"
              items={[
                {
                  title: (
                    <span style={{ fontWeight: "bold" }}>
                      {t("Config About Us")}
                    </span>
                  ),
                },
              ]}
            />
          </Row>
          <hr />
        </div>
      </Content>

      <Content style={{ padding: "0px 30px 20px 30px" }}>
        <Form
          form={form}
          name="image-upload-form"
          layout="vertical"
          onFinish={handleCreateAbout}
          style={{
            maxWidth: "1200px",
            margin: "0 auto",
            padding: "24px 0px 24px 0px",
          }}
        >
          {/* config about us */}
          <Card
            title="ตั้งค่าในส่วน About us"
            style={{
              width: "100%",
              backgroundColor: "#F3F3F1",
              borderColor: "#cccccc",
              marginBottom: 20,
            }}
          >
            <Form.Item>
              <Dragger
                name="file"
                accept=".png, .jpeg, .jpg"
                multiple={false}
                showUploadList={false}
                onChange={async (info: any) => {
                  const file = info.file.originFileObj;
                  if (file) {
                    setImageUrluse(file);
                    getBase64(file, (imageUrl: string) =>
                      setImageUrl(imageUrl)
                    );
                  } else {
                    console.error("File is undefined");
                  }
                }}
              >
                {imageUrl ? (
                  <img src={imageUrl} alt="avatar" className="show-image" />
                ) : (
                  <div>
                    <p className="ant-upload-drag-icon">
                      <InboxOutlined />
                    </p>
                    <p className="ant-upload-text">
                      {t("Drag your image here, or browse")}
                    </p>
                    <p className="ant-upload-hint">
                      {t("Support Only PNG and JPEG files are allowed")}
                    </p>
                  </div>
                )}
              </Dragger>

              <Alert
                style={{ marginTop: 20 }}
                showIcon
                message={`${t("The image size should be")} 1024 * 537`}
                type="info"
                closable
              />

              {imageUrl && (
                <Content
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Button
                    type="default"
                    danger
                    icon={<DeleteOutlined />}
                    style={{
                      marginTop: "10px",
                      justifyContent: "center",
                    }}
                    onClick={() => {
                      form.setFieldsValue({ img: null });
                      setImageUrl(null);
                    }}
                  >
                    {t("Delete")}
                  </Button>
                </Content>
              )}
            </Form.Item>

            <Form.Item
              // name="detail"
              // initialValue={editorContent}
              label="ข้อมูลเกี่ยวกับเรา"
              rules={[{ required: false, message: "Please input the title!" }]}
            >
              <EditorContentPage
                value={editorContentAbout}
                onChange={setEditorContentAbout}
              />
            </Form.Item>
          </Card>


          {/* config footer */}
          <Card title="ตั้งค่าในส่วน Contact Us" style={{ marginBottom: 20 }}>
            <Row gutter={8} align="middle">
              <Col xs={24} md={12}>
                <Form.Item
                  name="facebook"
                  label={
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                        gap: "1rem",
                      }}
                    >
                      <div style={{ flex: "1" }}>facebook</div>
                      <Form.Item
                        name="facebook_show"
                        valuePropName="checked"
                        noStyle
                      >
                        <Checkbox>{t("Show")}</Checkbox>
                      </Form.Item>
                    </div>
                  }
                >
                  <Input placeholder="facebook" />
                </Form.Item>
              </Col>

              <Col flex="auto">
                <Form.Item
                  name="Line"
                  label={
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                        gap: "1rem",
                      }}
                    >
                      <div style={{ flex: "1" }}>Wechat</div>
                      <Form.Item
                        name="Line_show"
                        valuePropName="checked"
                        noStyle
                      >
                        <Checkbox>{t("Show")}</Checkbox>
                      </Form.Item>
                    </div>
                  }
                >
                  <Input placeholder="Line" />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={8} align="middle">
              <Col xs={24} md={12}>
                <Form.Item
                  name="Email"
                  label={
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                        gap: "1rem", // เพิ่มระยะห่างระหว่าง elements
                      }}
                    >
                      <div style={{ flex: "1" }}>Email</div>
                      <Form.Item
                        name="Email_show"
                        valuePropName="checked"
                        noStyle
                      >
                        <Checkbox>{t("Show")}</Checkbox>
                      </Form.Item>
                    </div>
                  }
                >
                  <Input placeholder="Email" />
                </Form.Item>
              </Col>

              <Col flex="auto">
                <Form.Item
                  name="Tiktok"
                  label={
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                        gap: "1rem", // เพิ่มระยะห่างระหว่าง elements
                      }}
                    >
                      <div style={{ flex: "1" }}>X</div>
                      <Form.Item
                        name="Tiktok_show"
                        valuePropName="checked"
                        noStyle
                      >
                        <Checkbox>{t("Show")}</Checkbox>
                      </Form.Item>
                    </div>
                  }
                >
                  <Input placeholder="Tiktok" />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={8} align="middle">
              <Col xs={24} md={12}>
                <Form.Item
                  name="Phonenumber"
                  label={
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                        gap: "1rem", // เพิ่มระยะห่างระหว่าง elements
                      }}
                    >
                      <div style={{ flex: "1" }}>Phone Number</div>
                      <Form.Item
                        name="Phonenumber_show"
                        valuePropName="checked"
                        noStyle
                      >
                        <Checkbox>{t("Show")}</Checkbox>
                      </Form.Item>
                    </div>
                  }
                >
                  <Input placeholder="Phone Number" />
                </Form.Item>
              </Col>
            </Row>

            <Form.Item
              name="address"
              label={
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%",
                    gap: "1rem", // เพิ่มระยะห่างระหว่าง elements
                  }}
                >
                  <div style={{ flex: "1" }}>ที่อยู่เรา</div>
                  <Form.Item
                    name="address_show"
                    valuePropName="checked"
                    noStyle
                  >
                    <Checkbox>{t("Show")}</Checkbox>
                  </Form.Item>
                </div>
              }
            >
              <Input placeholder="ที่อยู่เรา" />
            </Form.Item>
          </Card>


          {/* button summit */}
          <Form.Item>
            <Popconfirm
              title={
                params.action === "create"
                  ? t("Alert confirm create title")
                  : t("Alert confirm update title")
              }
              description={
                params.action === "create"
                  ? t("Alert confirm create detail")
                  : t("Alert confirm update detail")
              }
              onConfirm={() => form.submit()}
              okText={t("yes")}
              cancelText={t("no")}
            >
              <Button
                type="primary"
                htmlType="button"
                loading={submitting}
                style={{ float: "right", width: "100px" }}
              >
                {params.action === "create" ? t("create") : t("update")}
              </Button>
            </Popconfirm>

            <Popconfirm
              title={t("Alert title")}
              description={t(
                "Are you sure you want to cancel and return to the news page"
              )}
              onConfirm={() => navigate("/news")}
              okText={t("yes")}
              cancelText={t("no")}
            >
              <Button
                style={{ marginRight: "10px", float: "right", width: "100px" }}
              >
                {t("cancel")}
              </Button>
            </Popconfirm>
          </Form.Item>
        </Form>
      </Content>
    </div>
  );
};

export default CreateAboutus;
